export default "/images/90094494d7dcaa42c750ab6377a58c9b.png";